import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';

// Lazy load pages
const ListSkillsScoringOptionsPage = loadable(() => import('./ListSkillsScoringOptionsPage'), {
  fallback: <Loader />,
});

const SkillsScoringOptionsRoute = ({ t }) => {
  return (
    <Routes>
      <Route path="list/:skillId" element={<ListSkillsScoringOptionsPage t={t} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

SkillsScoringOptionsRoute.propTypes = {
  t: PropTypes.func,
};

export default SkillsScoringOptionsRoute;